'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var utils = require('./utils.js');
var stickySection = require('./sticky-section.scss.js');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefault(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);
var cx__default = /*#__PURE__*/_interopDefault(cx);

var _excluded = ["children", "anchor", "expandedContent", "expandTrigger", "collapseTrigger", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var StickySection = function StickySection(props) {
  var children = props.children,
    anchor = props.anchor,
    expandedContent = props.expandedContent,
    expandTrigger = props.expandTrigger,
    collapseTrigger = props.collapseTrigger,
    className = props.className,
    rest = _objectWithoutProperties__default.default(props, _excluded);
  var _useState = react.useState(false),
    _useState2 = _slicedToArray__default.default(_useState, 2),
    showExpanded = _useState2[0],
    setShowExpanded = _useState2[1];
  var getAnchorClass = function getAnchorClass() {
    switch (anchor) {
      case 'top':
        return stickySection.default['anchor-top'];
      default:
        return stickySection.default['anchor-bottom'];
    }
  };
  var shouldShowExpanded = react.useCallback(function () {
    var shouldExpand = !(expandTrigger !== null && expandTrigger !== void 0 && expandTrigger.current);
    if (expandTrigger !== null && expandTrigger !== void 0 && expandTrigger.current) {
      shouldExpand = utils.hasElementEnteredViewport(expandTrigger.current);
    }
    if (shouldExpand && collapseTrigger !== null && collapseTrigger !== void 0 && collapseTrigger.current) {
      shouldExpand = !utils.hasElementEnteredViewport(collapseTrigger.current);
    }
    setShowExpanded(shouldExpand);
  }, [expandTrigger, collapseTrigger]);
  react.useEffect(function () {
    shouldShowExpanded();
    window.addEventListener('scroll', shouldShowExpanded);
    return function () {
      window.removeEventListener('scroll', shouldShowExpanded);
    };
  }, [shouldShowExpanded]);
  return /*#__PURE__*/jsxRuntime.jsxs("div", _objectSpread(_objectSpread({
    className: cx__default.default(stickySection.default['sticky-container'], getAnchorClass(), className)
  }, rest), {}, {
    children: [children, expandedContent && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: cx__default.default('overflow-hidden', showExpanded ? stickySection.default['expansion-show'] : stickySection.default['expansion-hide']),
      children: expandedContent
    })]
  }));
};
StickySection.defaultProps = {
  anchor: 'bottom'
};
StickySection.propTypes = {
  /**
   * class that gets applied to Sticky container
   */
  className: PropTypes__default.default.string,
  /**
   * content inside of the sticky section
   */
  children: PropTypes__default.default.node,
  /**
   * Content that appears when StickySection expands
   */
  expandedContent: PropTypes__default.default.node,
  /**
   * Reference to element that triggers expansion when it scrolls into view
   */
  expandTrigger: PropTypes__default.default.shape({
    current: PropTypes__default.default.instanceOf(Element)
  }),
  /**
   * Reference to element that triggers collapse when it scrolles into view
   */
  collapseTrigger: PropTypes__default.default.shape({
    current: PropTypes__default.default.instanceOf(Element)
  }),
  /**
   * Where in viewport sticky section should anchor:
   *
   * 'bottom' || 'top'
   */
  anchor: PropTypes__default.default.string
};
StickySection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StickySection",
  "props": {
    "anchor": {
      "defaultValue": {
        "value": "'bottom'",
        "computed": false
      },
      "description": "Where in viewport sticky section should anchor:\r\n\r\n'bottom' || 'top'",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "description": "class that gets applied to Sticky container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "content inside of the sticky section",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "expandedContent": {
      "description": "Content that appears when StickySection expands",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "expandTrigger": {
      "description": "Reference to element that triggers expansion when it scrolls into view",
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "instanceOf",
            "value": "Element",
            "required": false
          }
        }
      },
      "required": false
    },
    "collapseTrigger": {
      "description": "Reference to element that triggers collapse when it scrolles into view",
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "instanceOf",
            "value": "Element",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};
var StickySection$1 = StickySection;

exports.default = StickySection$1;
//# sourceMappingURL=StickySection.js.map
